import api from "api";

/**
 * Ouvre un document temporaire du FormBuilder
 * (sans contexte métier)
 */
export async function FormBuilderOpenDocument(path) {
  if (!path) {
    throw new Error("formBuilderOpenDocument: path manquant");
  }
  return api.post(
    "/formbuilder/document/open",
    { path },
    { responseType: "blob" }
  );
}
